import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IAuthService } from '@intigral/domain/lib/application/services/AuthService';
import { Button, Switch } from '@intigral/shared';
import { useMutation } from '@tanstack/react-query';
import { useContext } from 'react';
import users from '../../../actions/users';
import { BRAZE } from '../../../config/analytics-events';
import { EVENT, KEYS } from '../../../contexts/MixpanelConstants';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import channelsUtil from '../../../helpers/channelsUtil';
import useBraze from '../../../hooks/useBraze';
import { __ } from '../../../translations';
import { getUserInfo } from '../../../utils/user';
import { isGuestUser } from '../../../config/guestMode';
import useMediaQueries from './../../../hooks/useMediaQueries';
const ConsentFooter = ({ onToggle, onSubmit, question, isChecked }) => {
    const { isMobile } = useMediaQueries();
    const { track, setUserProperties, reset } = useContext(MixpanelContext) as any;
    const { logBrazeCustomEvent, flushBrazeData } = useBraze();

    const { mutate: logoutUser, isPending } = useMutation({
        mutationFn: async () => {
            const user = getUserInfo();
            if (isGuestUser(user)) {
                return null;
            }
            return await container
                .resolve<IAuthService>(DI.SERVICES.IAuthService)
                .logout(user.username, user.authToken, user.identityToken, user.authSign);
        },
        onSuccess: async () => {
            await logoutHandler();
        },
        onError: async (_error: any) => {
            await logoutHandler();
        },
    });

    const logoutHandler = async () => {
        setUserProperties({
            [KEYS.PEOPLE.LAST_SIGN_OUT]: channelsUtil.getCurrentDateTime(),
        });
        track(EVENT.LOGIN.SIGN_OUT);
        track(EVENT.CONSENT.CONSENT_TC_SIGNOUT);
        logBrazeCustomEvent(BRAZE.EVENTS.APP_SIGNOUT);
        reset();
        users.logoutUser();
        await flushBrazeData();
    };

    return (
        <>
            {question?.isMandatory && (
                <Button
                    // secondary={!isMobile && true}
                    plain={isMobile && true}
                    onClick={() => logoutUser()}
                    disabled={isChecked}
                    data-test-id="consent-management-logout-button"
                >
                    {__('settings_logout')}
                </Button>
            )}
            <Switch
                onChange={(value) => onToggle(question?.id, question?.isMandatory, value.target.checked)}
                checked={isChecked}
                reverse
                label={__(`consent_${question?.id}_terms_toggle_text`)}
                data-test-id="consent-management-toggle-button"
            />
            <Button
                disabled={question?.isMandatory && !isChecked}
                onClick={onSubmit}
                data-test-id="consent-management-next-button"
            >
                {__('mini_EPG_next')}
            </Button>
        </>
    );
};

export default ConsentFooter;
